<template>
    <!-- 일정 등록·수정 (SHELTER_SCHEDULE) — 홈 캘린더·동물 상세·입양신청서 상세 공통. utils/scheduleStore 참고 -->
    <Transition name="fade">
        <div v-if="form" class="modal-area" style="z-index: 1110;" tabindex="-1" ref="area" @keyup.esc="close()" @click.self="close()">
            <div class="modal-wrapper sf-wrapper">
                <div class="modal-container sf">
                    <div class="sf-head">
                        <h3>{{ form.idx ? '일정 수정' : '일정 추가' }}</h3>
                        <button type="button" class="btn-close ms-auto" @click="close()"></button>
                    </div>
                    <div class="sf-body">
                        <input type="text" class="form-control sf-input sf-title" v-model="form.title" placeholder="제목" maxlength="200" ref="titleInput"/>
                        <div class="sf-cats">
                            <button v-for="c in CATEGORIES" :key="c.key" type="button" class="sf-cat" :class="{ on: form.category == c.key }" :style="{ '--c': c.color, '--bg': c.color + '1F' }" @click="form.category = c.key">{{ c.key }}</button>
                        </div>
                        <div class="sf-row">
                            <label class="sf-label">날짜</label>
                            <div class="sf-field hstack gap-2 flex-wrap">
                                <input type="date" class="form-control sf-input sf-date" v-model="form.date"/>
                                <span class="fc-gray">~</span>
                                <input type="date" class="form-control sf-input sf-date" v-model="form.end_date" :min="form.date"/>
                            </div>
                        </div>
                        <div class="sf-row">
                            <label class="sf-label">시간</label>
                            <div class="sf-field sf-time-field">
                                <label class="sf-allday"><input type="checkbox" class="form-check-input mt-0" v-model="form.allDay"/> 종일</label>
                                <div v-if="!form.allDay" class="sf-tp-row">
                                    <div class="sf-tp"><TimeSelect v-model="form.time" label="시작"/><span class="sf-tp-word">부터</span></div>
                                    <div class="sf-tp"><TimeSelect v-model="form.end_time" optional label="끝"/><span class="sf-tp-word">까지 <small>(선택)</small></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="sf-row">
                            <label class="sf-label">담당자</label>
                            <div class="sf-field"><input type="text" class="form-control sf-input" v-model="form.manager" placeholder="담당자 (선택)" maxlength="100"/></div>
                        </div>
                        <!-- 공고 / 입양신청서 연결 (공용 메모와 같은 방식: 찾아서 고름).
                             동물 상세·신청서의 [일정 잡기]로 연 일정은 그 동물·신청서로 고정 (× / 찾기 없음) -->
                        <div class="sf-row sf-row-top">
                            <label class="sf-label">공고</label>
                            <div class="sf-field">
                                <div class="sf-attach">
                                    <!-- 신청서를 연결하면 공고는 그 신청서의 동물. 공고 ×는 신청서 연결도 함께 뺌 -->
                                    <span v-if="form.notify_number" class="sf-chip" :title="form.request_idx ? '연결한 신청서의 동물' : ''"><i class="bi bi-tag"></i> {{ form.animal_name ? form.animal_name + ' · ' : '' }}{{ form.notify_number }}<i class="bi bi-x sf-chip-x" :title="form.request_idx ? '공고 연결 빼기 (신청서 연결도 함께 빠져요)' : '연결 빼기'" @click="clearAnimal()"></i></span>
                                    <template v-else-if="!form.locked_notify">
                                        <button type="button" class="sf-link-btn" :class="{ on: pick.open && pick.kind == 'animal' }" @click="openPick('animal')"><i class="bi bi-search"></i> 공고 찾기</button>
                                        <span class="sf-hint">(선택)</span>
                                    </template>
                                </div>
                                <div v-if="pick.open && pick.kind == 'animal'" class="sf-pick">
                                    <div class="sf-pick-head">
                                        <input ref="pickInputanimal" class="form-control sf-input sf-pick-input" v-model="pick.q" @input="searchSoon()" :placeholder="'이름·공고번호·내부번호'"/>
                                        <button type="button" class="sf-pick-x" title="닫기" @click="pick.open = false"><i class="bi bi-x-lg"></i></button>
                                    </div>
                                    <div class="sf-pick-list">
                                        <p v-if="pick.loading" class="sf-pick-empty">찾는 중…</p>
                                        <p v-else-if="!pick.results.length" class="sf-pick-empty">{{ pick.q ? '찾는 결과가 없어요' : '이름이나 공고번호를 입력하세요' }}</p>
                                        <button v-for="r in pick.results" :key="r.key" type="button" class="sf-pick-row" @click="setLink(r)">
                                            <span class="sf-pick-main">{{ r.label }}</span>
                                            <span class="sf-pick-sub">{{ r.sub }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sf-row sf-row-top" v-if="!form.locked_notify || form.request_idx">
                            <label class="sf-label">신청서</label>
                            <div class="sf-field">
                                <div class="sf-attach">
                                    <span v-if="form.request_idx" class="sf-chip"><i class="bi bi-file-earmark-text"></i> {{ form.applicant || '입양신청서' }}{{ form.animal_name ? ' · ' + form.animal_name : '' }}<i v-if="!form.locked_notify" class="bi bi-x sf-chip-x" title="연결 빼기" @click="clearRequest()"></i></span>
                                    <template v-else-if="!form.locked_notify">
                                        <button type="button" class="sf-link-btn" :class="{ on: pick.open && pick.kind == 'request' }" @click="openPick('request')"><i class="bi bi-search"></i> 신청서 찾기</button>
                                        <span class="sf-hint">(선택)</span>
                                    </template>
                                </div>
                                <div v-if="pick.open && pick.kind == 'request'" class="sf-pick">
                                    <div class="sf-pick-head">
                                        <input ref="pickInputrequest" class="form-control sf-input sf-pick-input" v-model="pick.q" @input="searchSoon()" :placeholder="'신청자·공고번호·동물 이름'"/>
                                        <button type="button" class="sf-pick-x" title="닫기" @click="pick.open = false"><i class="bi bi-x-lg"></i></button>
                                    </div>
                                    <div class="sf-pick-list">
                                        <p v-if="pick.loading" class="sf-pick-empty">찾는 중…</p>
                                        <p v-else-if="!pick.results.length" class="sf-pick-empty">{{ pick.q ? '찾는 결과가 없어요' : '검색어를 입력하세요' }}</p>
                                        <button v-for="r in pick.results" :key="r.key" type="button" class="sf-pick-row" @click="setLink(r)">
                                            <span class="sf-pick-main">{{ r.label }}</span>
                                            <span class="sf-pick-sub">{{ r.sub }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sf-row sf-row-top">
                            <label class="sf-label">메모</label>
                            <div class="sf-field"><textarea class="form-control sf-input" v-model="form.memo" rows="3" placeholder="메모 (선택)" maxlength="2000"></textarea></div>
                        </div>
                    </div>
                    <div class="sf-foot">
                        <button v-if="form.idx" type="button" class="btn btn-outline-danger me-auto" @click="remove()">삭제</button>
                        <button type="button" class="btn btn-light" @click="close()">취소</button>
                        <button type="button" class="btn btn-orange" :disabled="saving" @click="save()">{{ form.idx ? '수정 완료' : '저장' }}</button>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import { SCHEDULE_CATEGORIES, removeSchedule } from '@/utils/scheduleStore';
import TimeSelect from '@/components/common/TimeSelect.vue';
const moment = require('moment');

export default {
    name: 'ScheduleFormModal',
    components: { TimeSelect },
    data() {
        return { CATEGORIES: SCHEDULE_CATEGORIES.filter(c => !c.legacy), form: null, origin: '', shelter: '', saving: false,
            pick: { open: false, kind: 'animal', q: '', results: [], loading: false, timer: null, seq: 0 } };
    },
    methods: {
        //params: { shelter_device_number, event: 수정할 일정 | preset: { date, category, title, notify_number, animal_name, request_idx, applicant } }
        open(params) {
            const p = params || {};
            this.shelter = p.shelter_device_number || '';
            const e = p.event;
            const pre = p.preset || {};
            this.form = e ? {
                idx: e.idx, title: e.title, category: e.category || '기타', date: e.date, end_date: e.end_date || '',
                allDay: !e.time, time: e.time || '10:00', end_time: e.end_time || '', manager: e.manager || '', memo: e.memo || '',
                notify_number: e.notify_number || '', animal_name: e.animal_name || '', request_idx: e.request_idx || null, applicant: e.applicant || '',
                locked_notify: false,   //수정: 공고·신청서 칸에서 바꿀 수 있음 (서버가 같은 보호소 신청서인지 확인)
            } : {
                idx: null, title: pre.title || '', category: pre.category || '상담', date: pre.date || moment().format('YYYY-MM-DD'), end_date: '',
                allDay: pre.time ? false : true, time: pre.time || '10:00', end_time: '', manager: '', memo: '',
                notify_number: pre.notify_number || '', animal_name: pre.animal_name || '', request_idx: pre.request_idx || null, applicant: pre.applicant || '',
                locked_notify: !!(pre.notify_number || pre.request_idx),
            };
            this.pick.open = false;
            this.origin = JSON.stringify(this.form);
            this.$nextTick(() => { if (this.$refs.titleInput) this.$refs.titleInput.focus(); });
        },
        // ── 공고·신청서 연결 (공용 메모와 같은 검색 API) ──
        openPick(kind) {
            this.pick.open = true;
            this.pick.kind = kind;
            this.pick.q = '';
            this.search();
            this.$nextTick(() => { const el = this.$refs['pickInput' + kind]; if (el) el.focus(); });
        },
        searchSoon() {
            clearTimeout(this.pick.timer);
            this.pick.timer = setTimeout(() => this.search(), 300);
        },
        search() {
            const kind = this.pick.kind, q = (this.pick.q || '').trim();
            //동물은 검색어가 있어야 (보호소 동물이 많음), 신청서는 비우면 최근 것
            if (kind == 'animal' && !q) { this.pick.results = []; return; }
            const my = ++this.pick.seq;
            this.pick.loading = true;
            const sh = this.shelter ? '&shelter_device_number=' + encodeURIComponent(this.shelter) : '';
            this.axios.get('/shelter/memo/targets?kind=' + kind + '&q=' + encodeURIComponent(q) + sh)
                .then(res => {
                    if (my != this.pick.seq) return;
                    const rows = Array.isArray(res.data) ? res.data : [];
                    this.pick.results = kind == 'animal'
                        ? rows.map(r => ({ key: 'a' + r.notify_number, kind, notify_number: r.notify_number, animal_name: r.animal_name,
                            label: (r.animal_name ? r.animal_name + ' · ' : '') + r.notify_number, sub: [r.management_number, r.state].filter(v => v).join(' · ') }))
                        : rows.map(r => ({ key: 'r' + r.idx, kind, request_idx: r.idx, applicant: r.applicant, notify_number: r.notify_number, animal_name: r.animal_name,
                            label: (r.applicant || '신청서') + ' · ' + (r.animal_name || r.notify_number), sub: [r.state, r.request_date].filter(v => v).join(' · ') }));
                })
                .catch(() => { if (my == this.pick.seq) this.pick.results = []; })
                .finally(() => { if (my == this.pick.seq) this.pick.loading = false; });
        },
        //공고를 고르면 공고만, 신청서를 고르면 그 신청서 + 신청서의 동물 (서버도 동물을 채움)
        setLink(target) {
            const f = this.form;
            if (target.kind == 'animal') { f.notify_number = target.notify_number; f.animal_name = target.animal_name || ''; }
            if (target.kind == 'request') { f.request_idx = target.request_idx; f.applicant = target.applicant || ''; f.notify_number = target.notify_number || ''; f.animal_name = target.animal_name || ''; }
            this.pick.open = false;
        },
        //공고를 빼면 그 동물의 신청서 연결도 함께 뺌 (신청서 = 그 동물). 동물 상세·신청서에서 연 일정도 빼면 다시 찾을 수 있게
        clearAnimal() {
            const f = this.form;
            f.notify_number = ''; f.animal_name = ''; f.request_idx = null; f.applicant = '';
            f.locked_notify = false;
        },
        //신청서만 빼고 동물은 남김 (동물도 빼려면 공고 칸에서 ×)
        clearRequest() { this.form.request_idx = null; this.form.applicant = ''; },
        close() {
            if (this.form && JSON.stringify(this.form) !== this.origin && !confirm('저장되지 않은 내용은 삭제됩니다. 창을 닫으시겠습니까?')) return;
            this.form = null;
        },
        save() {
            const f = this.form;
            if (!f.title || !f.title.trim()) { alert('제목을 입력해주세요.'); return; }
            if (!f.date) { alert('날짜를 입력해주세요.'); return; }
            const body = {
                title: f.title, category: f.category, date: f.date, end_date: f.end_date || null,
                time: f.allDay ? null : (f.time || null), end_time: f.allDay ? null : (f.end_time || null),
                manager: f.manager, notify_number: f.notify_number || null, request_idx: f.request_idx, memo: f.memo,
            };
            const q = this.shelter ? `?shelter_device_number=${encodeURIComponent(this.shelter)}` : '';
            const call = f.idx ? this.axios.put(`/shelter/schedule/${f.idx}`, body) : this.axios.post('/shelter/schedule' + q, body);
            this.saving = true;
            call.then(res => {
                const r = res.data || {};
                if (r.result == 'YES') {
                    this.$root.showToastMsg('', '일정', r.resultMsg || '저장되었습니다.', 'default');
                    this.form = null;
                    this.emitter.emit('scheduleChanged', { notify_number: body.notify_number, request_idx: body.request_idx, idx: f.idx || parseInt(r.resultInfo, 10) });
                } else {
                    alert(r.resultMsg || '저장에 실패했습니다.');
                }
            }).catch(e => { console.log(e); alert('저장 중 오류가 발생했습니다.'); })
              .finally(() => { this.saving = false; });
        },
        remove() {
            const f = this.form;
            removeSchedule(this, { idx: f.idx, title: f.title, notify_number: f.notify_number, request_idx: f.request_idx })
                .then(ok => { if (ok) this.form = null; });
        },
    },
    mounted() {
        this.emitter.on('openScheduleForm', this.open);
    },
    beforeUnmount() {
        this.emitter.off('openScheduleForm', this.open);
    },
};
</script>

<style scoped>
    .sf p, .sf button, .sf label, .sf span, .sf input, .sf textarea { font-size: 13px !important; }
    .sf-wrapper { width: min(480px, 96vw); margin: 6vh auto; }
    .sf { padding: 0 !important; text-align: left; }
    .sf-head { display: flex; align-items: center; padding: 12px 16px; border-bottom: 1px solid #ececec; }
    .sf-head h3 { font-size: 17px; font-weight: 700; margin: 0; }
    .sf-body { padding: 14px 18px; }
    .sf .sf-input { background: #F1F3F7; border: 1px solid transparent; padding: 6px 10px; }
    .sf .sf-input:focus { background: #fff; border-color: #f6951c; }
    .sf .sf-title { font-size: 16px !important; font-weight: 600; margin-bottom: 10px; }
    .sf-cats { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 14px; }
    .sf .sf-cat { border: 1px solid #dcdcdc; background: #fff; color: #666; border-radius: 14px; padding: 2px 12px; font-weight: 600; }
    .sf .sf-cat.on { border-color: var(--c); background: var(--bg); color: var(--c); }
    .sf-row { display: flex; gap: 10px; align-items: center; margin-bottom: 10px; }
    .sf-row-top { align-items: flex-start; }
    .sf .sf-label { width: 56px; flex-shrink: 0; font-weight: 700; color: #333; margin: 0; }
    .sf-row-top .sf-label { padding-top: 6px; }
    .sf-field { flex: 1; min-width: 0; }
    .sf .sf-date { width: 150px; }
    .sf .sf-time { width: 120px; }
    .sf-tp { display: inline-flex; align-items: center; gap: 4px; }
    .sf-time-field { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }
    .sf-tp-row { display: flex; flex-direction: column; gap: 6px; }
    .sf .sf-tp-word { color: #555; margin-left: 4px; }
    .sf .sf-tp-word small { color: #a0a0a0; font-size: 12px !important; }
    .sf-attach { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; min-height: 32px; }
    .sf .sf-link-btn { border: 1px dashed #cfcfcf; background: #fff; color: #666; border-radius: 14px; padding: 3px 12px; font-weight: 600; }
    .sf .sf-link-btn:hover, .sf .sf-link-btn.on { border-color: #f6951c; color: #E07F06; background: #FFF6EA; }
    .sf .sf-hint { color: #a0a0a0; font-size: 12px !important; }
    .sf .sf-chip { display: inline-flex; align-items: center; gap: 5px; background: #FFF3E3; color: #B86208; border-radius: 14px; padding: 3px 6px 3px 12px; font-weight: 600; }
    .sf .sf-chip-x { cursor: pointer; font-size: 15px; color: #c99a5b; }
    .sf .sf-chip-x:hover { color: #E53935; }
    .sf-pick { margin-top: 8px; border: 1px solid #ececec; border-radius: 10px; padding: 8px; background: #fff; box-shadow: 0 4px 14px rgba(0, 0, 0, .06); }
    .sf-pick-head { display: flex; align-items: center; gap: 6px; margin-bottom: 6px; }
    .sf .sf-pick-input { flex: 1; min-width: 0; }
    .sf .sf-pick-x { border: none; background: none; color: #999; padding: 2px 6px; }
    .sf-pick-list { max-height: 190px; overflow-y: auto; display: flex; flex-direction: column; }
    .sf .sf-pick-row { display: flex; flex-direction: column; align-items: flex-start; border: none; background: none; text-align: left; padding: 6px 8px; border-radius: 6px; }
    .sf .sf-pick-row:hover { background: #FFF6EA; }
    .sf .sf-pick-main { color: #222; font-weight: 600; }
    .sf .sf-pick-sub { color: #999; font-size: 12px !important; }
    .sf .sf-pick-empty { color: #a0a0a0; margin: 6px 8px !important; }
    .sf-allday { display: inline-flex; align-items: center; gap: 5px; margin: 0 6px 0 0; cursor: pointer; }
    .sf-foot { display: flex; justify-content: flex-end; gap: 6px; padding: 12px 16px; border-top: 1px solid #ececec; }
    .sf-foot .btn { padding: 5px 18px; font-weight: 700; }

    /* 모바일: 아래 시트 가로 꽉 차게, 이름은 칸 위로, 입력칸 16px(iOS 확대 방지), 저장 버튼 아래 고정 */
    @media (max-width: 768px) {
        .sf-wrapper { width: 100% !important; margin: 0 !important; }
        .sf { display: flex; flex-direction: column; max-height: 92dvh; }
        .sf-body { overflow-y: auto; flex: 1 1 auto; padding: 12px 16px; }
        .sf-head .btn-close { padding: 10px; }
        .sf p, .sf button, .sf label, .sf span { font-size: 14px !important; }
        .sf input, .sf textarea, .sf .sf-input { font-size: 16px !important; }
        .sf .sf-input { padding: 8px 10px; }
        .sf .sf-cat { padding: 6px 14px; }
        .sf-row { flex-direction: column; align-items: stretch; gap: 4px; margin-bottom: 12px; }
        .sf .sf-label { width: auto; }
        .sf-row-top .sf-label { padding-top: 0; }
        .sf-field.hstack { flex-wrap: nowrap !important; }
        .sf .sf-date, .sf .sf-time { width: auto; flex: 1 1 0; min-width: 0; }
        .sf-allday { flex: none; min-height: 40px; }
        .sf-foot { padding: 10px 16px calc(10px + env(safe-area-inset-bottom)); }
        .sf-foot .btn { flex: 1; min-height: 44px; }
        .sf-foot .btn-outline-danger { flex: 0 0 auto; }
    }
</style>
